import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import cn from 'classnames';
import './Menu.scss';

type Props = {
  menuItems: Array<{
    icon?: React.ReactNode;
    title: string;
    to: string;
    href?: string;
    isButton?: boolean;
    onClick?: () => void;
  }>;
  mods: string;
  mix: string;
};

const Menu: React.FC<Props> = (props) => {
  const { menuItems, mods, mix } = props;
  const location = useLocation();

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const renderItems = () =>
    menuItems.map((menuItem) => {
      const { title, to, href, isButton, onClick } = menuItem;
      const regexp = new RegExp(`^${to}$`);

      // eslint-disable-next-line consistent-return
      function renderItemContent() {
        if (
          regexp.test(location.pathname) &&
          (mods === 'menu_type_main-navigation' || mods === 'menu_type_context')
        ) {
          return <span className="menu__item-content">{title}</span>;
        }

        if (to) {
          return (
            <Link className="menu__item-content" to={to} {...(onClick && { onClick })}>
              {title}
            </Link>
          );
        }

        if (href) {
          const itemContentProps = {
            className: 'menu__item-content',
            href: isButton ? '#' : href,
          };

          if (isButton) {
            // @ts-ignore
            itemContentProps.role = 'button';
          }

          if (onClick) {
            // @ts-ignore
            itemContentProps.onClick = onClick;
          }

          return <a {...itemContentProps}>{title}</a>;
        }
      }

      return (
        <li
          key={title}
          className={cn(
            'menu__item',
            regexp.test(location.pathname) && 'menu__item_current menu__item_selected'
          )}
        >
          {renderItemContent()}
        </li>
      );
    });

  return <ul className={cn('menu', mods, mix)}>{renderItems()}</ul>;
};

export default Menu;
